import { getSessionToken } from '@descope/web-js-sdk';

const SIGNED_OUT = {
  email: '',
  token: '',
};

// Decode the (unverified) claims of a JWT. The API verifies the signature; the
// app only needs the email and expiry to decide whether to make a call.
function decodeClaims(token) {
  const encoded = token.split('.')[1].replace(/-/g, '+').replace(/_/g, '/');
  const padded = encoded + '='.repeat((4 - (encoded.length % 4)) % 4);
  return JSON.parse(window.atob(padded));
}

/**
 * Reads the current Descope session and extracts the email and token.
 * @returns {{email: string, token: string}} The current session identity.
 */
export function getSessionIdentity() {
  try {
    const token = getSessionToken();

    if (!token) {
      return SIGNED_OUT;
    }

    const claims = decodeClaims(token);

    if (!claims.exp || claims.exp * 1000 <= Date.now()) {
      return SIGNED_OUT;
    }

    return {
      email: claims.email || '',
      token,
    };
  } catch (error) {
    console.warn('Unable to read the Descope session identity.', error);
    return SIGNED_OUT;
  }
}

/**
 * Authorization header carrying the Descope session token.
 * @param {{token: string}} identity - Result of getSessionIdentity().
 */
export function bearerHeaders(identity) {
  return { Authorization: `Bearer ${identity.token}` };
}
